<div class="card card-fit chart-card" *ngIf="item && item.chartType !== chartTypes.UNSET">
  <div class="card-body">
    <app-form-metrics-pie-widget
      *ngIf="item.chartType === chartTypes.PIZZA"
      [item]="item"
      [categoryClickEnabled]="categoryClickEnabled"
      [highlightAnswers]="highlightAnswers"
      (categoryClick)="onCategoryClick($event)">
    </app-form-metrics-pie-widget>

    <app-form-metrics-bar-widget
      *ngIf="item.chartType === chartTypes.BAR"
      [item]="item"
      [categoryClickEnabled]="categoryClickEnabled"
      [highlightAnswers]="highlightAnswers"
      (categoryClick)="onCategoryClick($event)">
    </app-form-metrics-bar-widget>

    <app-form-metrics-thermometer-widget
      *ngIf="item.chartType === chartTypes.THERMOMETER"
      [item]="item"
      [categoryClickEnabled]="categoryClickEnabled"
      [highlightAnswers]="highlightAnswers"
      (categoryClick)="onCategoryClick($event)">
    </app-form-metrics-thermometer-widget>

    <app-form-metrics-binary-thermometer-widget
      *ngIf="item.chartType === chartTypes.BINARY_THERMOMETER"
      [item]="item"
      [categoryClickEnabled]="categoryClickEnabled"
      [highlightAnswers]="highlightAnswers"
      (categoryClick)="onCategoryClick($event)">
    </app-form-metrics-binary-thermometer-widget>

    <app-form-metrics-comments-widget
      *ngIf="item.chartType === chartTypes.COMMENT"
      [item]="item"
      [highlightedEmployeeId]="highlightedEmployeeId"
      [highlightAnswers]="highlightAnswers"
      (viewAll)="onViewAllComments($event)">
    </app-form-metrics-comments-widget>

    <app-form-metrics-temporal-widget
      *ngIf="item.chartType === chartTypes.TEMPORAL_EVOLUTION"
      [item]="item">
    </app-form-metrics-temporal-widget>
  </div>
</div>
